import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import RedAsterisk from "../RedAsterisk/RedAsterisk";
import DefaultPopover from "../Popover/DefaultPopover";
const WithAsterisk = ({ message, children }) => {
    const contentWithAsterisk = (_jsxs(_Fragment, { children: [children, _jsx(RedAsterisk, {})] }));
    return message ? (_jsx(DefaultPopover, { popoverBehavior: "hover", popoverContent: message, children: (provided) => (_jsx("span", Object.assign({}, provided.popoverProps, { children: contentWithAsterisk }))) })) : (contentWithAsterisk);
};
export default WithAsterisk;
